import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  DataGrid,
  GridToolbar,
} from "@mui/x-data-grid";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
    Select,
    InputLabel
} from "@mui/material";

import { fetchSuppliers } from '../service/supplierService';
import certificateService from '../service/certificateService'; 

const CertificateManager = () => {
  const [certificates, setCertificates] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [suppliers, setSuppliers] = useState([]);

  const [form, setForm] = useState({
    certificateId: null,
    name: "",
    certificateNumber: "",
    type: "",
    issueDate: "",
    expiryDate: "",
    issuingAuthority: "",
    documentUrl: "",
    supplierId: "",
  });

  useEffect(() => {
    fetchCertificates();
        fetchAllSuppliers();
  }, []);
    
        const fetchAllSuppliers = async () => {
    const res = await fetchSuppliers();
    setSuppliers(res.data);
  };

      const handleSupplierChange = (e) => {
    // The value from the Select component is the supplierId.
    const selectedSupplierId = e.target.value;

    // Update the state with the selected supplier's ID.
    setForm({
      ...form,
      supplierId: selectedSupplierId,
    });
  };
  const fetchCertificates = async () => {
    try {
      const response = await certificateService.fetchSupplierCertificate();// axios.get("/api/certificates");
      setCertificates(response);
    } catch (error) {
      console.error("Error fetching certificates", error);
    }
  };

  const handleOpen = (cert) => {
    if (cert) {
      setForm(cert);
      setEditing(cert);
    } else {
      setForm({
        certificateId: null,
        name: "",
        certificateNumber: "",
        type: "",
        issueDate: "",
        expiryDate: "",
        issuingAuthority: "",
        documentUrl: "",
        supplierId: "",
      });
      setEditing(null);
    }
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
    
             if (
    !form.certificateNumber ||
    !form.name ||
    !form.type ||
    !form.issueDate ||
    !form.expiryDate ||
    !form.issuingAuthority ||
    !form.documentUrl ||
    !form.supplierId
  ) {
    alert("Please fill in all required fields.");
    return;
  }

      if (editing) {
        await certificateService.updateCertificate(form.certificateId, form); // axios.put(`/api/certificates/${form.certificateId}`, form);
      } else {
        await certificateService.saveCertificate(form); //axios.post("/api/certificates", form);
      }
      fetchCertificates();
      handleClose();
    } catch (error) {
      console.error("Error saving certificate", error);
    }
  };

  const handleDelete = async (id) => {
      if (window.confirm("Are you sure you want to delete this Certificate?")) {
    try {
      await certificateService.deleteSupplierCertificate(id);
      fetchCertificates();
    } catch (error) {
      console.error("Error deleting certificate", error);
    }
      }
  };

  const columns = [
    { field: "certificateId", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "certificateNumber", headerName: "Number", flex: 1 },
    { field: "type", headerName: "Type", flex: 1 },
    { field: "issueDate", headerName: "Issue Date", flex: 1 },
    { field: "expiryDate", headerName: "Expiry Date", flex: 1 },
    { field: "issuingAuthority", headerName: "Authority", flex: 1 },
    { field: "documentUrl", headerName: "Doc URL", flex: 1 },
    { field: "supplierName", headerName: "Supplier Name", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params) => (
        <>
          <Button
            size="small"
            onClick={() => handleOpen(params.row)}
          >
            Edit
          </Button>
          <Button
            size="small"
            color="error"
            onClick={() => handleDelete(params.row.certificateId)}
          >
            Delete
          </Button>
        </>
      ),
      width: 180,
    },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <Button variant="contained" onClick={() => handleOpen(null)}>
        Add Certificate
      </Button>
      <DataGrid
        rows={certificates}
        columns={columns}
        getRowId={(row) => row.certificateId}
        components={{ Toolbar: GridToolbar }}
      />

      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>
          {editing ? "Edit Certificate" : "Add Certificate"}
        </DialogTitle>
        <DialogContent>
                
               <InputLabel id="supplier-label">Supplier</InputLabel>
      <Select
        labelId="supplier-label"
        id="supplierId"
        // Set the value of the Select to the selected supplier's ID.
        value={form.supplierId || ''}
        onChange={handleSupplierChange}
        label="Supplier"
        required
        width="20px"
      >
        <MenuItem value="">
          <em>Select Supplier</em>
        </MenuItem>
        {suppliers.map((sup) => (
          // Use the unique ID as the value for each MenuItem.
          <MenuItem key={sup.supplierId} value={sup.supplierId}>
            {sup.supplierName}
          </MenuItem>
        ))}
      </Select>
          <TextField
            margin="dense"
            label="Name"
            name="name"
            fullWidth
            value={form.name}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Certificate Number"
            name="certificateNumber"
            fullWidth
            value={form.certificateNumber}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Type"
            name="type"
            fullWidth
            value={form.type}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Issue Date"
            name="issueDate"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.issueDate}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Expiry Date"
            name="expiryDate"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.expiryDate}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Issuing Authority"
            name="issuingAuthority"
            fullWidth
            value={form.issuingAuthority}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Document URL"
            name="documentUrl"
            fullWidth
            value={form.documentUrl}
            onChange={handleChange}
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CertificateManager;
